module.exports = __webpack_public_path__ + "static/media/scrubber.4be32c24.svg";